<template>
    <div class="story-maker-sticker story-maker-sticker-hashtag" :class="{edit : isSelected}" @click="finish">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <!-- <p class="text-finish" @click="()=>finish()">Terminé</p> -->
        <div 
            class="sticker sticker-hashtag" 
            :class="`style${stickerInstance.data.styleVariant}`"
            @click="stickerInstance.nextStyleVariant"
        >
        <div class="icon"></div>
        <p
            :contenteditable="isSelected"
            @input="handlerInput"
            ref="hashtagInput"
            v-html="stickerInstance.data.hashtag"
            class="textarea"
        ></p>
    </div>

    <div class="hashtags hide-scrollbar" @wheel="handleHorizontalScroll">
        <div class="hashtag" v-for="h in hashtags" @click="()=>selectHashtag(h.hashtag)">
            <!-- <img :src="m.image ? m.image : 'img/avatar.jpg'" alt=""> -->
            <p>#{{h.hashtag}}</p>
        </div>
    </div>
</div>
</template>

<script>

import minxinBots from '@/components/mixins/Bots.vue'
export default {
    mixins: [minxinBots],
    
    props: {
        id: [Number, String],
        isSelected: Boolean,
        stickerInstance: {
            type: Object,
            required: true
        },
    },
    
    data() {
        return {
            cursorPosition: null,
            timeoutInitSearch: null,
            stateLoader: true,
            hashtags:[]
        };
    },
    
    mounted () {
     
        if(this.isSelected) {
            this.$refs[`hashtagInput`].focus();
        }
    },
    methods: {
        handlerInput(e) {
            this.updateCursorPosition()
            this.stickerInstance.data.hashtag = e.target.innerHTML
            const newTextMention = e.target.innerHTML.replaceAll(' ',''); 

            this.$nextTick(() => {
                if (e.target.innerHTML !== newTextMention) {
                    this.stickerInstance.data.hashtag = newTextMention
                    this.cursorPosition = this.cursorPosition > 0 ? this.cursorPosition - 1 : 0
                    this.$nextTick(() => {
                        this.restoreCursorPosition()
                        this.searchHashtags()
                    })
                }else{
                    this.restoreCursorPosition()
                    this.searchHashtags()
                }
            })
        },

        focusAtEnd(element) {
            if (!element || !element.isContentEditable) return;

            const range = document.createRange();
            const selection = window.getSelection();

            range.selectNodeContents(element);
            range.collapse(false);

            selection.removeAllRanges();
            selection.addRange(range);

            // Donnez le focus à l'élément
            element.focus();
        },
        
        updateCursorPosition() {
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                let nodeIndex = 0
                if (this.cursorPosition !== range.startOffset) {
                    this.cursorPosition = range.startOffset
                }
            }
        },
        
        restoreCursorPosition() {
            this.$refs[`hashtagInput`].focus();
            let node = this.$refs[`hashtagInput`].childNodes[0]
            const selection = window.getSelection();
            selection.removeAllRanges();
            const range = document.createRange();
            range.setStart(node, this.cursorPosition);
            range.collapse(true);
            selection.addRange(range);
        },

        selectHashtag(value) {
            this.stickerInstance.data.hashtag = value
            this.finish()
        },
        

        finish(event) {
            if (this.isSelected && event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish')) {
                this.$emit('unselect')
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch);

                if (!this.stickerInstance.data.hashtag.replace(/<br>/g, '').replace(/[^a-zA-Z0-9]/g, '')) {
                    this.$emit('deleteSticker')
                }
            }
        },

        async searchHashtags() {
            if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
            this.stateLoader = true
            this.timeoutInitSearch = setTimeout(async () => {
                let page = null   
                page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
             
                if (page && this.$refs[`hashtagInput`].innerText) {
                    this.stateLoader = true
                    this.hashtags = (await this.getHashtagsByApi(page.id, this.$refs[`hashtagInput`].innerText)).body.hashtags
                    this.stateLoader = false
                }
            },1000)
        },

        handleHorizontalScroll(event) {
            if (event.deltaX == 0) {
                event.preventDefault();
                const scrollContainer = event.currentTarget;
                scrollContainer.scrollLeft += event.deltaY;
            }
        }
    },
    

    watch: {
        isSelected: {
            handler(newValue) {
                if (newValue) {
                    this.$nextTick(()=> {
                        this.focusAtEnd(this.$refs[`hashtagInput`]);
                    })
                }
            },
            immediate: true
        },
    },
    
    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
        },
    },
};
</script>
